import React from 'react'
import styles from './JobPostThirdPageView.module.scss'
import { useState, useEffect, useRef } from 'react'
import { useAuthStatus } from '../../utils'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { fetchTours, flattenToursResponse } from '../../services/api'
import { formatDateToYYYYMMDD } from '../../utils/date'
import { IS_PERIOD_CONTRACT_SELECTION_DISABLED } from '../../config/featureFlags'
import GeneralContractInfoSubmitForm from './GeneralContractInfoSubmitForm'
import DomesticContractInfoSubmitForm from './DomesticContractInfoSubmitForm'
import OverseasContractInfoSubmitForm from './OverseasContractInfoSubmitForm'
import { InformationCircleIcon } from '@heroicons/react/24/solid'
import { Tooltip } from 'react-tooltip'

const JobPostThirdPageView = () => {
	const navigate = useNavigate()
	const [authStatus] = useAuthStatus()
	const [userAssociation, setUserAssociation] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)

	const [informationDisplayOption, setInformationDisplayOption] = useState(null)
	const [previousSessionData, setPreviousSessionData] = useState(null)
	const [jobPostContractStartDate, setJobPostContractStartDate] = useState(null)
	const [jobPostContractEndDate, setJobPostContractEndDate] = useState(null)
	const [formValidations, setFormValidations] = useState({
		general: false,
		domestic: false,
		overseas: false,
	})

	// 폼 refs
	const generalFormRef = useRef()
	const domesticFormRef = useRef()
	const overseasFormRef = useRef()
	const [longContractStartDate, setLongContractStartDate] = useState(null)
	const [longContractEndDate, setLongContractEndDate] = useState(null)
	const [informationForDisplay, setInformationForDisplay] = useState({
		contractType: null,
		selectedTours: null,
		contractStartDate: null,
		contractEndDate: null,
		periodType: null,
		isTourSelected: null,
		currentYear: null,
		isOverseasContract: false,
		isDomesticContract: false,
		isGeneralContract: false,
		isShortContract: false,
		isLongContract: false,
		selectedToursData: [],
	})
	const [jobPostPeriodType, setJobPostPeriodType] = useState(null)
	const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

	useEffect(() => {
		if (!IS_PERIOD_CONTRACT_SELECTION_DISABLED) return
		if (sessionStorage.getItem('JobPostContractType') === 'period') {
			navigate('/posts/create/type', { replace: true })
		}
	}, [navigate])

	useEffect(() => {
		if (
			informationForDisplay.selectedToursData &&
			informationForDisplay.selectedToursData.length > 0
		) {
			// 시작날짜가 가장 이른 것 찾기
			const earliestStartDate = informationForDisplay.selectedToursData.reduce(
				(earliest, tour) => {
					return tour.startDate < earliest ? tour.startDate : earliest
				},
				informationForDisplay.selectedToursData[0].startDate,
			)

			// 끝날짜가 가장 늦은 것 찾기
			const latestEndDate = informationForDisplay.selectedToursData.reduce((latest, tour) => {
				return tour.endDate > latest ? tour.endDate : latest
			}, informationForDisplay.selectedToursData[0].endDate)

			// 상태 업데이트
			setLongContractStartDate(earliestStartDate)
			setLongContractEndDate(latestEndDate)

			// 지역별 계약 타입 설정
			informationForDisplay.selectedToursData.forEach((tour) => {
				if (tour.region === 'DOMESTIC') {
					setInformationForDisplay((prev) => ({
						...prev,
						isDomesticContract: true,
					}))
				} else if (tour.region === 'INTERNATIONAL') {
					setInformationForDisplay((prev) => ({
						...prev,
						isOverseasContract: true,
					}))
				}
			})
		}
	}, [informationForDisplay.selectedToursData])

	// 이전 계약 데이터 가져오기 - informationForDisplay가 설정된 후에만 실행
	useEffect(() => {
		const fetchPreferredContract = async () => {
			try {
				const userID = authStatus.user.id
				const response = await axios.get(
					`${API_ENDPOINT}/users/${userID}/preferred-contract`,
				)
				console.log('response : ', response)
				console.log('response.data : ', response.data)
				const contractType = sessionStorage.getItem('JobPostContractType')
				console.log('contractType : ', contractType)

				if (contractType === 'short' || contractType === 'long') {
					const selectedTours = JSON.parse(sessionStorage.getItem('JobPostSelectedTours'))
					console.log('selectedTours : ', selectedTours)

					console.log(
						'response.data?.overseasContract : ',
						response.data?.overseasContract,
					)
					console.log(
						'response.data?.domesticContract : ',
						response.data?.domesticContract,
					)

					// 해외 계약 폼이 있고 이전 데이터가 있는 경우
					if (
						informationForDisplay.isOverseasContract &&
						response.data?.overseasContract
					) {
						// 이전 해외 계약 데이터를 sessionStorage에 저장하여 폼에서 사용할 수 있도록 함
						sessionStorage.setItem(
							'OverseasContractPreviousData',
							JSON.stringify(response.data.overseasContract),
						)
						console.log('해외 계약 이전 데이터 저장:', response.data.overseasContract)
					}

					// 국내 계약 폼이 있고 이전 데이터가 있는 경우
					if (
						informationForDisplay.isDomesticContract &&
						response.data?.domesticContract
					) {
						// 이전 국내 계약 데이터를 sessionStorage에 저장하여 폼에서 사용할 수 있도록 함
						sessionStorage.setItem(
							'DomesticContractPreviousData',
							JSON.stringify(response.data.domesticContract),
						)
						console.log('국내 계약 이전 데이터 저장:', response.data.domesticContract)
					}

					// 일반 계약 폼이 있고 이전 데이터가 있는 경우
				}
			} catch (err) {
				console.error('데이터 가져오기 실패:', err)
				console.error('에러 메시지:', err.message || '데이터를 가져오는데 실패했습니다.')
			}
		}

		// informationForDisplay가 설정된 후에만 실행
		if (informationForDisplay.selectedToursData !== undefined) {
			fetchPreferredContract()
		}
	}, [authStatus.user?.id, API_ENDPOINT, informationForDisplay.selectedToursData])

	// 컴포넌트 마운트 시 이전 ThirdPageData 삭제
	useEffect(() => {
		sessionStorage.removeItem('ThirdPageData')
	}, [])

	// validation 상태를 상위 컴포넌트로 전달
	const handleValidationChange = (formType, isValid) => {
		setFormValidations((prev) => ({
			...prev,
			[formType]: isValid,
		}))
	}

	const loadSelectedToursDataFromSession = async (jobPostSelectedToursRaw) => {
		const selectedToursIds = JSON.parse(jobPostSelectedToursRaw)
		const flat = flattenToursResponse(await fetchTours(undefined))
		const selectedTours = flat.filter((tour) => selectedToursIds.includes(tour.id))
		const toYmd = (value) => {
			if (value == null || value === '') return ''
			const d = value instanceof Date ? value : new Date(value)
			return Number.isNaN(d.getTime()) ? '' : formatDateToYYYYMMDD(d)
		}
		return selectedTours.map((tour) => {
			const startRaw = tour.startedAt ?? tour.started_at
			const endRaw = tour.endedAt ?? tour.ended_at
			return {
				id: tour.id,
				name: tour.name,
				startDate: toYmd(startRaw),
				endDate: toYmd(endRaw),
				region: tour.region,
				category: tour.TourCategory,
			}
		})
	}

	const setDataFromPreviousPage = async () => {
		const jobPostContractType = sessionStorage.getItem('JobPostContractType')
		const jobPostSelectedTours = sessionStorage.getItem('JobPostSelectedTours')
		const jobPostCurrentYear = sessionStorage.getItem('JobPostCurrentYear')
		const periodType = sessionStorage.getItem('JobPostPeriodType')
		setJobPostPeriodType(periodType)

		console.log('계약 타입:', jobPostContractType)
		console.log('선택된 투어:', jobPostSelectedTours)
		// console.log('기간 타입:', jobPostPeriodType)

		if (jobPostContractType === 'period' && jobPostSelectedTours === '[]') {
			const isGeneralContract = true
			console.log('선택된 투어가 없습니다.')

			let endDate = ''
			let displayOption = ''

			if (periodType.includes('last-half') && periodType.includes('first-half')) {
				console.log('상하반기 선택됨')
				endDate = `${jobPostCurrentYear}-12-31`
				displayOption = 'period-no-tour-first-half-last-half'
			} else if (periodType.includes('first-half')) {
				console.log('상반기 선택됨')
				endDate = `${jobPostCurrentYear}-06-30`
				displayOption = 'period-no-tour-first-half'
			} else if (periodType.includes('last-half')) {
				console.log('하반기 선택됨')
				endDate = `${jobPostCurrentYear}-12-31`
				displayOption = 'period-no-tour-last-half'
			}

			setInformationForDisplay({
				contractType: jobPostContractType,
				selectedTours: jobPostSelectedTours,
				contractStartDate: '계약일',
				contractEndDate: endDate,
				periodType: periodType,
				isTourSelected: false,
				currentYear: jobPostCurrentYear,
				isGeneralContract: isGeneralContract,
			})

			setInformationDisplayOption(displayOption)
			console.log('설정된 정보:', {
				contractType: jobPostContractType,
				selectedTours: jobPostSelectedTours,
				contractStartDate: '계약일',
				contractEndDate: endDate,
				periodType: periodType,
				isTourSelected: false,
				currentYear: jobPostCurrentYear,
			})
			console.log('설정할 displayOption : ', displayOption)
		} else if (jobPostContractType === 'period' && jobPostSelectedTours !== '[]') {
			const isGeneralContract = true
			try {
				const selectedToursData =
					await loadSelectedToursDataFromSession(jobPostSelectedTours)
				console.log('selectedToursData : ', selectedToursData)
				const displayOption = 'period-tour-selected'
				setInformationDisplayOption(displayOption)

				// 지역별 계약 타입 설정
				let isDomesticContract = false
				let isOverseasContract = false
				selectedToursData.forEach((tour) => {
					if (tour.region === 'DOMESTIC') {
						isDomesticContract = true
					} else if (tour.region === 'INTERNATIONAL') {
						isOverseasContract = true
					}
				})

				setInformationForDisplay((prev) => ({
					...prev,
					isGeneralContract: isGeneralContract,
					selectedToursData: selectedToursData,
					isDomesticContract: isDomesticContract,
					isOverseasContract: isOverseasContract,
				}))
			} catch (err) {
				console.error('데이터 가져오기 실패:', err)
				console.error('에러 메시지:', err.message || '데이터를 가져오는데 실패했습니다.')
			}
		} else if (jobPostContractType === 'short') {
			const isShortContract = true
			try {
				const selectedToursData =
					await loadSelectedToursDataFromSession(jobPostSelectedTours)
				console.log('selectedToursData : ', selectedToursData)
				const displayOption = 'short-contract'
				setInformationDisplayOption(displayOption)

				// 지역별 계약 타입 설정
				let isDomesticContract = false
				let isOverseasContract = false
				selectedToursData.forEach((tour) => {
					if (tour.region === 'DOMESTIC') {
						isDomesticContract = true
					} else if (tour.region === 'INTERNATIONAL') {
						isOverseasContract = true
					}
				})

				setInformationForDisplay((prev) => ({
					...prev,
					isShortContract: isShortContract,
					selectedToursData: selectedToursData,
					isDomesticContract: isDomesticContract,
					isOverseasContract: isOverseasContract,
				}))
			} catch (err) {
				console.error('데이터 가져오기 실패:', err)
				console.error('에러 메시지:', err.message || '데이터를 가져오는데 실패했습니다.')
			}
		} else if (jobPostContractType === 'long') {
			const isLongContract = true
			try {
				const selectedToursData =
					await loadSelectedToursDataFromSession(jobPostSelectedTours)
				console.log('selectedToursData : ', selectedToursData)
				const displayOption = 'long-contract'
				setInformationDisplayOption(displayOption)

				// 지역별 계약 타입 설정
				let isDomesticContract = false
				let isOverseasContract = false
				selectedToursData.forEach((tour) => {
					if (tour.region === 'DOMESTIC') {
						isDomesticContract = true
					} else if (tour.region === 'INTERNATIONAL') {
						isOverseasContract = true
					}
				})

				setInformationForDisplay((prev) => ({
					...prev,
					isLongContract: isLongContract,
					selectedToursData: selectedToursData,
					isDomesticContract: isDomesticContract,
					isOverseasContract: isOverseasContract,
				}))
			} catch (err) {
				console.error('데이터 가져오기 실패:', err)
				console.error('에러 메시지:', err.message || '데이터를 가져오는데 실패했습니다.')
			}
		}
	}

	useEffect(() => {
		const initializeData = async () => {
			await setDataFromPreviousPage()
		}
		initializeData()

		const fetchData = async () => {
			// 인증 상태가 로드되었고 사용자가 인증된 경우에만 요청
			if (authStatus.state === 'loaded' && authStatus.isAuthentication && authStatus.user) {
				const userId = authStatus.user.id

				if (userId) {
					setLoading(true)
					setError(null)

					try {
						const response = await axios.get(
							`${process.env.REACT_APP_API_ENDPOINT}/users/player/email?userId=${userId}`,
						)

						setUserAssociation(response.data.playerType)
					} catch (err) {
						console.error('데이터 가져오기 실패:', err)
						console.error(
							'에러 메시지:',
							err.message || '데이터를 가져오는데 실패했습니다.',
						)
					} finally {
						setLoading(false)
					}
				}
			} else if (authStatus.state === 'loaded' && !authStatus.isAuthentication) {
				console.log('사용자가 로그인되지 않았습니다.')
			}
		}

		fetchData()
	}, [authStatus])

	// informationDisplayOption 상태 변화 감지
	useEffect(() => {
		console.log('informationDisplayOption 상태 업데이트됨:', informationDisplayOption)
	}, [informationDisplayOption])

	const prepareDataForSubmit = () => {
		console.log('prepareDataForSubmit')
		const data = {
			selectedYear: sessionStorage.getItem('JobPostCurrentYear'),
			userAssociation: userAssociation,
			periodType: jobPostPeriodType,
			contractType: informationDisplayOption,
			isGeneralContract: informationForDisplay.isGeneralContract,
			isOverseasContract: informationForDisplay.isOverseasContract,
			isDomesticContract: informationForDisplay.isDomesticContract,
			selectedToursData: informationForDisplay.selectedToursData,
		}

		// 각 폼의 데이터 수집
		if (informationForDisplay.isGeneralContract) {
			data.generalFormData = generalFormRef.current?.getFormData?.()
		}
		if (informationForDisplay.isDomesticContract) {
			data.domesticFormData = domesticFormRef.current?.getFormData?.()
		}
		if (informationForDisplay.isOverseasContract) {
			data.overseasFormData = overseasFormRef.current?.getFormData?.()
		}

		console.log('data : ', data)
		return data
	}

	return (
		<div className={styles.jobPostThirdPageContainer}>
			<div className={styles.title}>공고 작성</div>
			<div className={styles.progressBar}></div>
			<div className={styles.tourInformationDisplayWrapper}>
				<span className={styles.tourInformationDisplayWrapperTitle}>
					계약 기간 및 대회정보를 확인해주세요
				</span>
				<div className={styles.tourInformationContainer}>
					{authStatus.state === 'loaded' && authStatus.isAuthentication && (
						<>
							{userAssociation && (
								<span className={styles.userAssociation}>{userAssociation}</span>
							)}
							{informationDisplayOption === 'period-no-tour-last-half' && (
								<>
									<div>
										<span className={styles.contractType}>기간계약</span>
										<span className={styles.contractTypeDetail}>
											(하반기,대회미정)
										</span>
									</div>
									<span className={styles.contractPeriod}>
										{`계약일 ~ ${informationForDisplay.currentYear}-12-31`}
										<InformationCircleIcon
											className={styles.noticeIcon}
											data-tooltip-id="my-tooltip4"
											data-tooltip-content={`계약기간은 공식연습일과 예비일 등이 포함될 수 있습니다.`}
										/>
										<Tooltip
											id="my-tooltip4"
											place="top"
											className={styles.tooltip}
										/>
									</span>
								</>
							)}
							{informationDisplayOption === 'period-no-tour-first-half' && (
								<>
									<div>
										<span className={styles.contractType}>기간계약</span>
										<span className={styles.contractTypeDetail}>
											(상반기,대회미정)
										</span>
									</div>
									<span className={styles.contractPeriod}>
										{`계약일 ~ ${informationForDisplay.currentYear}-06-30`}
										<InformationCircleIcon
											className={styles.noticeIcon}
											data-tooltip-id="my-tooltip5"
											data-tooltip-content={`계약기간은 공식연습일과 예비일 등이 포함될 수 있습니다.`}
										/>
										<Tooltip
											id="my-tooltip5"
											place="top"
											className={styles.tooltip}
										/>
									</span>
								</>
							)}
							{informationDisplayOption === 'period-no-tour-first-half-last-half' && (
								<>
									<div>
										<span className={styles.contractType}>기간계약</span>
										<span className={styles.contractTypeDetail}>
											(상반기,하반기,대회미정)
										</span>
									</div>
									<span className={styles.contractPeriod}>
										{`계약일 ~ ${informationForDisplay.currentYear}-12-31`}
										<InformationCircleIcon
											className={styles.noticeIcon}
											data-tooltip-id="my-tooltip6"
											data-tooltip-content={`계약기간은 공식연습일과 예비일 등이 포함될 수 있습니다.`}
										/>
										<Tooltip
											id="my-tooltip6"
											place="top"
											className={styles.tooltip}
										/>
									</span>
								</>
							)}
							{informationDisplayOption === 'period-tour-selected' &&
								informationForDisplay.selectedToursData &&
								informationForDisplay.selectedToursData.length > 0 && (
									<>
										<div>
											<span className={styles.contractType}>기간계약</span>
											<span className={styles.contractTypeDetail}>
												(
												{jobPostPeriodType &&
												jobPostPeriodType.includes('first-half') &&
												jobPostPeriodType.includes('last-half')
													? '상반기,하반기, '
													: jobPostPeriodType &&
														  jobPostPeriodType.includes('first-half')
														? '상반기, '
														: '하반기, '}
												총 {informationForDisplay.selectedToursData.length}
												경기)
											</span>
										</div>
										<span className={styles.contractPeriod}>
											{informationForDisplay.selectedToursData[0].startDate} ~{' '}
											{
												informationForDisplay.selectedToursData[
													informationForDisplay.selectedToursData.length -
														1
												].endDate
											}
											<InformationCircleIcon
												className={styles.noticeIcon}
												data-tooltip-id="my-tooltip7"
												data-tooltip-content={`계약기간은 공식연습일과 예비일 등이 포함될 수 있습니다.`}
											/>
											<Tooltip
												id="my-tooltip7"
												place="top"
												className={styles.tooltip}
											/>
										</span>
										<div className={styles.tourDisplayContainer}>
											{informationForDisplay.selectedToursData.map((tour) => (
												<div
													key={tour.id}
													className={styles.tourDisplayItem}>
													<span className={styles.tourRegion}>
														{tour.region === 'DOMESTIC'
															? '국내'
															: '해외'}
													</span>
													<span className={styles.tourName}>
														{tour.name}
													</span>
												</div>
											))}
										</div>
									</>
								)}
							{informationDisplayOption === 'short-contract' &&
								informationForDisplay.selectedToursData &&
								informationForDisplay.selectedToursData.length > 0 && (
									<>
										<div>
											<span className={styles.contractType}>단기계약</span>
											<span className={styles.contractTypeDetail}>
												(총 1경기)
											</span>
										</div>
										<span className={styles.contractPeriod}>
											{`${informationForDisplay.selectedToursData[0].startDate} ~ ${informationForDisplay.selectedToursData[0].endDate}`}
											<InformationCircleIcon
												className={styles.noticeIcon}
												data-tooltip-id="my-tooltip8"
												data-tooltip-content={`계약기간은 공식연습일과 예비일 등이 포함될 수 있습니다.`}
											/>
											<Tooltip
												id="my-tooltip8"
												place="top"
												className={styles.tooltip}
											/>
										</span>
										<div className={styles.tourDisplayContainer}>
											{informationForDisplay.selectedToursData.map((tour) => (
												<div
													key={tour.id}
													className={styles.tourDisplayItem}>
													<span className={styles.tourRegion}>
														{tour.region === 'DOMESTIC'
															? '국내'
															: '해외'}
													</span>
													<span className={styles.tourName}>
														{tour.name}
													</span>
												</div>
											))}
										</div>
									</>
								)}
							{informationDisplayOption === 'long-contract' &&
								informationForDisplay.selectedToursData &&
								informationForDisplay.selectedToursData.length > 0 && (
									<>
										<div>
											<span className={styles.contractType}>장기계약</span>
											<span className={styles.contractTypeDetail}>
												(총 {informationForDisplay.selectedToursData.length}
												경기)
											</span>
										</div>
										<span className={styles.contractPeriod}>
											{`${informationForDisplay.selectedToursData[0].startDate} ~ ${informationForDisplay.selectedToursData[informationForDisplay.selectedToursData.length - 1].endDate}`}
											<InformationCircleIcon
												className={styles.noticeIcon}
												data-tooltip-id="my-tooltip9"
												data-tooltip-content={`계약기간은 공식연습일과 예비일 등이 포함될 수 있습니다.`}
											/>
											<Tooltip
												id="my-tooltip9"
												place="top"
												className={styles.tooltip}
											/>
										</span>
										<div className={styles.tourDisplayContainer}>
											{informationForDisplay.selectedToursData.map((tour) => (
												<div
													key={tour.id}
													className={styles.tourDisplayItem}>
													<span className={styles.tourRegion}>
														{tour.region === 'DOMESTIC'
															? '국내'
															: '해외'}
													</span>
													<span className={styles.tourName}>
														{tour.name}
													</span>
												</div>
											))}
										</div>
									</>
								)}
						</>
					)}
				</div>
				{informationForDisplay.isGeneralContract && (
					<GeneralContractInfoSubmitForm
						ref={generalFormRef}
						onValidationChange={handleValidationChange}
						isOverseas={informationForDisplay.isOverseasContract}
					/>
				)}
				{!informationForDisplay.isGeneralContract &&
					informationForDisplay.isDomesticContract && (
						<DomesticContractInfoSubmitForm
							ref={domesticFormRef}
							onValidationChange={handleValidationChange}
						/>
					)}
				{!informationForDisplay.isGeneralContract &&
					informationForDisplay.isOverseasContract && (
						<OverseasContractInfoSubmitForm
							ref={overseasFormRef}
							onValidationChange={handleValidationChange}
						/>
					)}
			</div>

			{/* 통합 버튼 */}
			{(informationForDisplay.isGeneralContract ||
				informationForDisplay.isDomesticContract ||
				informationForDisplay.isOverseasContract) && (
				<div className={styles.whatsNext}>
					<div className={styles.whatsNextButtonContainer}>
						<button
							type="button"
							onClick={() => navigate(-1)}
							className={styles.beforeButton}>
							이전
						</button>
						<button
							type="button"
							onClick={() => {
								// 각 폼의 제출 로직을 여기서 처리
								const formData = prepareDataForSubmit()
								console.log('다음 버튼 클릭', formData)
								sessionStorage.setItem('ThirdPageData', JSON.stringify(formData))
								navigate('/posts/create/confirm')
							}}
							className={
								(() => {
									// 일반 계약인 경우
									if (informationForDisplay.isGeneralContract) {
										return formValidations.general
									}
									// 국내만 있는 경우
									if (
										informationForDisplay.isDomesticContract &&
										!informationForDisplay.isOverseasContract
									) {
										return formValidations.domestic
									}
									// 해외만 있는 경우
									if (
										informationForDisplay.isOverseasContract &&
										!informationForDisplay.isDomesticContract
									) {
										return formValidations.overseas
									}
									// 국내와 해외가 모두 있는 경우 둘 다 통과해야 함
									if (
										informationForDisplay.isDomesticContract &&
										informationForDisplay.isOverseasContract
									) {
										return formValidations.domestic && formValidations.overseas
									}
									return false
								})()
									? styles.nextButton
									: styles.nextButtonDisabled
							}>
							다음
						</button>
					</div>
				</div>
			)}
		</div>
	)
}
export default JobPostThirdPageView
